import { StackYoutubePlayerProps } from '../../StackYouTubePlayer/StackYouTubePlayer';
import { ContentfulYoutube } from '@jbhi-fi/apis/src/contentful/types';

export const contentfulYoutubeToYoutubePlayerProps = ({ fields }: ContentfulYoutube): StackYoutubePlayerProps => {
  return {
    videoUrl: fields?.url,
  };
};
